import { TypeChecker } from '@attain-apps/type-guards'

/**
 * {@link https://ngrx.io/docs State} of this feature
 */
export interface State {
  error?: Error
  /**
   * Comment to apply to every selected record. `undefined` while no bulk
   * comment is in progress.
   */
  comment?: string
  isSubmitting: boolean
}

export namespace State {
  export const INITIAL: Readonly<State> = {
    comment: undefined,
    error: undefined,
    isSubmitting: false,
  }

  /** Whether a bulk comment is in progress */
  export function isUpdating(state: State): boolean {
    return TypeChecker.isNotNullish(state.comment)
  }

  /**
   * Opens a bulk comment for the current selection.
   *
   * The comment always starts empty: the selected records may hold different
   * comments, and there is no one of them the field could honestly show.
   */
  export function onInitiate(): State {
    return { ...INITIAL, comment: '' }
  }

  /** Marks a bulk comment request as in flight */
  export function onRequest(state: State): State {
    return { ...state, error: undefined, isSubmitting: true }
  }

  /** Records a failed bulk comment request */
  export function onError(error: Error, state: State): State {
    return { ...state, error, isSubmitting: false }
  }

  /** Clears the in flight marker for a request that never ran */
  export function onCancellation(state: State): State {
    return { ...state, isSubmitting: false }
  }
}
